import * as React from "react";
const SvgCombined = (props) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 18, viewBox: "0 0 15 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 11.5L9 17.5L7.58 16.08L11.17 12.5H0V0.5H2V10.5H11.17L7.58 6.92L9 5.5L15 11.5Z", fill: "#B4B8B8" }));
export default SvgCombined;
